import React from "react";
import { LanguageProvider } from "./src/components/context/language-context";
import "./src/global.css";

export const wrapPageElement = ({ element, props }) => (
  <LanguageProvider {...props}>{element}</LanguageProvider>
);
